import { RouteObject } from "react-router-dom";
import { ClaimsDashboard } from "../pages/admin/claims/ClaimsDashboard";
import { ClaimsDossiersList } from "../pages/admin/claims/ClaimsDossiersList";
import { ClaimDossierDetail } from "../pages/admin/claims/ClaimDossierDetail";
import { ClaimRecoursesList } from "../pages/admin/claims/ClaimsRecoursesList";
import { ClaimsInsights } from "../pages/admin/claims/ClaimsInsights";
import ClaimKanbanOverview from "../pages/admin/claims/ClaimKanbanOverview";
import ClaimKanbanClaimsOverview from "../pages/admin/claims/ClaimKanbanClaimsOverview";
import ClaimKanbanHerstelOverview from "../pages/admin/claims/ClaimKanbanHerstelOverview";
import { ClaimsRankingConfig } from "../pages/admin/claims/ClaimsRankingConfig";

export const claimsRoutes: RouteObject[] = [
  {
    id: "claims-dashboard",
    path: "dashboard",
    element: <ClaimsDashboard />,
  },
  {
    id: "claims-dossiers-list",
    path: "dossiers",
    element: <ClaimsDossiersList />,
  },
  {
    id: "claims-dossier-detail",
    path: "dossiers/:id",
    element: <ClaimDossierDetail />,
  },
  {
    id: "claims-kanban-calculaties",
    path: "kanban/calculaties",
    element: <ClaimKanbanOverview />,
  },
  {
    id: "claims-kanban-claims",
    path: "kanban/claims",
    element: <ClaimKanbanClaimsOverview />,
  },
  {
    id: "claims-kanban-herstel",
    path: "kanban/herstel",
    element: <ClaimKanbanHerstelOverview />,
  },
  {
    id: "claims-recourses",
    path: "recourses",
    element: <ClaimRecoursesList />,
  },
  {
    id: "claims-ranking",
    path: "ranking",
    element: <ClaimsRankingConfig />,
  },
  {
    id: "claims-insights",
    path: "insights",
    element: <ClaimsInsights />,
  },
];
